import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Pencil, Plus } from 'lucide-react';
import { BIZ_SVG } from '../utils/icons';
import { customSelectStyles, makeIconComponents } from '../utils/selectStyles';
import { MODEL_KINDS } from '../utils/constants';

const bizBadgeComponents = makeIconComponents(BIZ_SVG);

class EntityModal extends React.Component {
    render() {
        const { show, onClose, onSave, entityModal, businesses, onChange } = this.props;

        const type = entityModal.type;

        return (
            <Modal 
                show={show} 
                onHide={onClose}
                dialogClassName="modal-vertical shadow" 
                className="fixed-right model__help modal-integration"
                size="xl"
            >
                <form onSubmit={(e) => { e.preventDefault(); onSave(); }} className="tw-flex tw-flex-col tw-h-full">
                    {/* Header */}
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/20 tw-bg-white dark:tw-bg-white/10 tw-rounded-[10px]'>
                                {type === 'business' ? <Pencil className="tw-text-[#414651] dark:tw-text-white tw-w-5 tw-h-5" strokeWidth={2.5} /> : <Plus className="tw-text-[#414651] dark:tw-text-white tw-w-5 tw-h-5" strokeWidth={2.5} />}
                            </div>
                            <div>
                                <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">
                                    {entityModal.id ? 'Edit ' : 'Add '}
                                    {type === 'business' ? 'Business' :
                                     type === 'function' ? 'Function' :
                                     type === 'kpi' ? 'KPI' : 'Model'}
                                </h5>
                                <p className='tw-text-xs tw-font-medium tw-text-[#525252] dark:tw-text-gray-400 tw-m-0'>
                                    {type === 'business' ? 'Create a new business' :
                                     type === 'function' ? 'Create a new function' :
                                     type === 'kpi' ? 'Create a new kpi' :
                                     'Create a new model'}
                                </p>
                            </div>
                        </div>
                    </Modal.Header>

                    {/* Body */}
                    {/* Body */}
                    <Modal.Body className="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden !tw-p-0 scr text-left tw-bg-slate-50/50 dark:tw-bg-[#1E1E2D]/50 max-h-[65vh]">
                        <div className="qd-configure-integration-steps !tw-p-5">
                            <div className="w-100">
                                    <div className="tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-white/10 tw-bg-[#FAFAFA] dark:tw-bg-white/5 tw-rounded-xl tw-p-4 tw-shadow-sm tw-space-y-4">
                                        {/* Parent Selection (Only when adding a Function) */}
                                        {!entityModal.id && type === 'function' && (
                                            <Form.Group className="tw-mb-0">
                                                <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1.5">
                                                    Parent Business
                                                </Form.Label>
                                                <Select
                                                    className="has-badge"
                                                    classNamePrefix="select-control"
                                                    placeholder="Select Business"
                                                    options={businesses.map(b => ({ value: b.id, label: b.name }))}
                                                    value={businesses.map(b => ({ value: b.id, label: b.name })).find(o => o.value === entityModal.presetParentId) || null}
                                                    onChange={opt => onChange('presetParentId', opt ? opt.value : '')}
                                                    components={bizBadgeComponents}
                                                    styles={customSelectStyles}
                                                />
                                                {entityModal.errors?.parent && (
                                                    <div className="invalid-feedback d-block">{entityModal.errors.parent}</div>
                                                )}
                                            </Form.Group>
                                        )}
                                        <Form.Group className="tw-mb-0">
                                            <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1">
                                                {type === 'business' ? 'Business name' :
                                                 type === 'function' ? 'Function name' :
                                                 type === 'kpi' ? 'KPI name' : 'Model name'}
                                            </Form.Label>
                                            <Form.Control 
                                                type="text"
                                                placeholder={type === 'business' ? 'e.g. Commercial' :
                                                             type === 'function' ? 'e.g. Sales Performance' :
                                                             type === 'kpi' ? 'e.g. Total Revenue' : 'e.g. Demand Forecast'}
                                                value={entityModal.name}
                                                onChange={e => onChange('name', e.target.value)}
                                                isInvalid={!!entityModal.errors?.name}
                                                className="tw-w-full tw-text-[13.5px] tw-text-slate-900 dark:tw-text-white tw-p-2 tw-px-3 tw-border tw-border-solid tw-border-slate-300 dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-outline-none focus:tw-border-blue-400 focus:tw-ring-3 focus:tw-ring-blue-500/15 tw-transition-all"
                                            />
                                            {entityModal.errors?.name && <Form.Control.Feedback type="invalid" className="tw-mt-1">{entityModal.errors.name}</Form.Control.Feedback>}
                                        </Form.Group>

                                        {/* Formula Field (KPI Only) */}
                                        {/* {type === 'kpi' && (
                                            <Form.Group className="tw-mb-0">
                                                <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1">Formula</Form.Label>
                                                <Form.Control 
                                                    type="text"
                                                    placeholder="e.g. SUM(transactions.amount)"
                                                    value={entityModal.formula || ''}
                                                    onChange={e => onChange('formula', e.target.value)}
                                                    className="tw-w-full tw-text-[13.5px] tw-text-slate-900 dark:tw-text-white tw-p-2 tw-px-3 tw-border tw-border-solid tw-border-slate-300 dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-outline-none focus:tw-border-blue-400 focus:tw-ring-3 focus:tw-ring-blue-500/15 tw-transition-all"
                                                />
                                            </Form.Group>
                                        )} */}

                                        {/* Model Type Field (Model Only) */}
                                        {type === 'model' && (
                                            <Form.Group className="tw-mb-0">
                                                <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1.5">Model type</Form.Label>
                                                <Select
                                                    classNamePrefix="select-control"
                                                    placeholder="Select Model Family"
                                                    options={MODEL_KINDS}
                                                    value={MODEL_KINDS.find(o => o.value === entityModal.kind) || null}
                                                    onChange={opt => onChange('kind', opt ? opt.value : 'Forecasting')}
                                                    styles={customSelectStyles}
                                                />
                                            </Form.Group>
                                        )}

                                        {/* Description Field */}
                                        <Form.Group className="tw-mb-0">
                                            <Form.Label className="tw-block tw-text-[12px] tw-font-semibold tw-text-slate-700 dark:tw-text-[#B2B5BE] tw-mb-1">Description</Form.Label>
                                            <Form.Control 
                                                as="textarea"
                                                rows={3}
                                                placeholder={type === 'business' ? 'What does this business represent?' :
                                                             type === 'function' ? 'What does this function represent?' :
                                                             type === 'kpi' ? 'What does this kpi represent?' : 'What does this model represent?'}
                                                value={entityModal.description || ''}
                                                onChange={e => onChange('description', e.target.value)}
                                                isInvalid={!!entityModal.errors?.description}
                                                className="tw-w-full tw-text-[13.5px] tw-text-slate-900 dark:tw-text-white tw-p-2 tw-px-3 tw-border tw-border-solid tw-border-slate-300 dark:tw-border-white/10 tw-rounded-lg tw-bg-white dark:tw-bg-[#2B2B40] tw-outline-none focus:tw-border-blue-400 focus:tw-ring-3 focus:tw-ring-blue-500/15 tw-transition-all"
                                            />
                                            {entityModal.errors?.description && (
                                                <Form.Control.Feedback type="invalid" className="tw-mt-1 d-block">
                                                    {entityModal.errors.description}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </div>
                            </div>

                        </div>
                    </Modal.Body>

                    {/* Footer */}
                    <div className="tw-flex tw-items-center tw-justify-end tw-py-3 tw-px-5 tw-border-0 tw-border-t tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-bg-white dark:tw-bg-white/5 tw-shrink-0 tw-gap-2">
                        <button 
                            type="button"
                            onClick={onClose} 
                            className="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-700 dark:tw-text-white tw-bg-white dark:tw-bg-[#2B2B40] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-white/10 tw-rounded-lg hover:tw-bg-gray-50 dark:hover:tw-bg-[#3A3A55] tw-transition-colors"
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            disabled={this.props.submitting}
                            className="btn btn-primary"
                        >
                            {this.props.submitting ? 'Saving...' :
                             entityModal.id ? 'Save Changes' :
                             type === 'business' ? '+ Add Business' :
                             type === 'function' ? '+ Add Function' :
                             type === 'kpi' ? '+ Add KPI' : '+ Add Model'}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

EntityModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    entityModal: PropTypes.object.isRequired,
    businesses: PropTypes.array.isRequired,
    functions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

EntityModal.defaultProps = {
    submitting: false
};

export default EntityModal;
